import { createActions } from 'helpers/actions'
import entityNames from 'options/entityNames'

export default createActions(entityNames.operatorGroups, { memoizeGetOptions: true })
